<template>
  <div
    class="is-fullwidth trial-notification-bar has-background-warning"
    v-if="show"
  >
    <div v-if="!needPayment">
      <div class="is-pulled-left">
        <p>
          <small>
            <strong>
              You have {{ timeLeft }} left of your free {{ plan }} trial.
            </strong>
            <span>
              Like what you see? Let's make it official by adding your
              credit card info - we <strong>won't</strong> charge you until the end of your trial.
            </span>
          </small>
        </p>
        <br class="is-hidden-tablet">
        <p v-if="user && user.newlyRegistered">
          <small>
            <em>
              We sent you an email. Please check your inbox and click the link to
              <strong>confirm your account</strong>. Check your
              <strong>Spam</strong> folder and mark the email as
              <strong>Safe</strong> if it's not in your inbox.
            </em>
          </small>
        </p>
      </div>
      <div class="is-pulled-right">
        <router-link class="button is-small is-primary" to="/profile/payment">
          Add Credit Card
        </router-link>
      </div>
    </div>
    <div v-if="needPayment">
      <p class="is-pulled-left">
        <small>
          <strong>
            Your trial period has ended.
          </strong>
          <span>
            You can continue using our platform on the
            <strong>Free plan</strong> or you can add
            your payment information and Upgrade using
            the button above.
          </span>
        </small>
      </p>
      <div class="is-pulled-right">
        <button type="button" class="button is-small is-info" @click="resetNotification">
          Got it!
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TrialNotificationBar',
  computed: {
    user() {
      return this.$store.getters['auth/getUser'];
    },
    plan() {
      const user = this.$store.getters['auth/getUser'];
      if (user && user._id) {
        return user.account.subscription.plan.name;
      }
      return false;
    },
    timeLeft() {
      const user = this.$store.getters['auth/getUser'];
      if (user && user._id) {
        return this.$moment(user.account.subscription.trialEnd).fromNow(true);
      }
      return false;
    },
    show() {
      const user = this.$store.getters['auth/getUser'];
      let show = false;
      const reg = /^free-/gi;
      if (user && user._id) {
        if (user.payment && user.payment.id && !user.downgraded) {
          // Don't show the bar if the user already has a payment method.
          show = false;
        } else if (
          !this.$moment().isBefore(user.account.subscription.trialEnd) &&
          // !(user.payment && user.payment.id) &&
          user.downgraded
        ) {
          // Show the bar if the trial is over and the user doesn't have a
          // payment method.
          show = true;
        } else {
          // Otherwise check the trial expiration date.
          show = this.$moment().isBefore(user.account.subscription.trialEnd);
        }
        // Test the stripe plan id for matches.
        if (
          reg.test(user.account.subscription.stripe.plan.id) &&
          !user.downgraded
        ) {
          // If we are on a free stripe plan (Free or God), don't show the bar.
          show = false;
        }
      }
      return show;
    },
    needPayment() {
      let show = false;
      const user = this.$store.getters['auth/getUser'];
      // Check if tial has ended and if the user needs to add
      // a payment method.
      if (
        !this.$moment().isBefore(user.account.subscription.trialEnd) &&
        // !(user.payment && user.payment.id) &&
        user.downgraded
      ) {
        show = true;
      }
      return show;
    }
  },
  methods: {
    resetNotification() {
      const data = {
        downgraded: false
      };
      this.$axios
        .patch(this.$API.updateProfile(this.user._id), data)
        .then(response => {
          this.$store.commit('auth/setUser', response.data);
          this.$notify({
            group: 'alert',
            title: 'Success!',
            text: `We won't bother you again with this notification`,
            type: 'success'
          });
        })
        .catch(e => {
          this.$notify({
            group: 'alert',
            title: 'FAILED!',
            text: `We weren't able to process the request. Please try again later.`,
            type: 'error'
          });
          console.error(e.response.data.message || e.message);
        });
    }
  }
};
</script>
